import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { User } from '../../shared/data-objects/user';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { LoginService } from '../../shared/services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserDetailsComponent } from '../../manage-users/user-details/user-details.component';
import { HttpErrorResponse } from '@angular/common/http';
import { FeatureToggle } from '../../shared/data-objects/feature-toggle';
import { FeatureToggleService } from '../../shared/services/feature-toggle.service';

const accountNoRE = /^999\d{8}$/;
const companyNameRE = /^(?:\s*[a-zA-Z0-9,_\.\077\0100\*\+\&\#\'\~\;\-\!\@\;\(\)]{2,}\s*)*$|^\s*$/;
// const abnAcnRE = /^(\d *?){9}$|^(\d *?){11}$|^\s*$/;
// const abnRE = /^\s*\d{3}\s*\d{3}\s*\d{3}\s*\d{1}\s*$/;
const abnRE = /^[1-9]\s*\d{2}\s*\d{3}\s*\d{3}\s*\d{3}$/;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, AfterViewInit {
  @ViewChild('focusInput') focusInputElement: ElementRef;
  @ViewChild('user') user: UserDetailsComponent;
  @ViewChild('registerBtn') registerBtn: ElementRef;

  applicantDetails: User;
  // accountNoControl: FormControl;
  companyNameControl: FormControl;
  // abnNumberControl: FormControl;
  confirmPasswordControl: FormControl;
  passwordControl: FormControl;

  passwordControlGroup: FormGroup;

  passwordControlMinLength = 8;

  isRequesting: boolean = false;

  submitErrorMessage: string;

  password: string;
  confirmPassword: string;

  agreedToTsAndCs: boolean;

  _feature: FeatureToggle;

  validQueryParams: boolean = false;
  userEmail: string;

  applicantType: string;
  applicantTypeControl: FormControl;

  validABN: boolean = true;

  pwdErrors: string = '';
  hasCompanyNameError: { status: boolean, msg: string } = { status: false, msg: '' };
  hasCompanyABNError: { status: boolean, msg: string } = { status: false, msg: '' };

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }
  }

  constructor(private loginService: LoginService, private router: Router, private featureToggleService: FeatureToggleService, private activatedRoute: ActivatedRoute) {
    this.applicantDetails = new User();
    this.applicantDetails.email = atob(this.activatedRoute.snapshot.queryParamMap.get('u') || '').toLowerCase();
    this.userEmail = atob(this.activatedRoute.snapshot.queryParamMap.get('u') || '').toLowerCase();
  }

  ngAfterViewInit(): void {
    if (this._feature && this.focusInputElement) {
      this.focusInputElement.nativeElement.focus();
    }
  }

  async ngOnInit() {

    await this.getUserDetailsFromToken();
    await this.getFeatureToggle();

    // this.accountNoControl = this._feature.DisableGuestUsers
    //   ? new FormControl('')
    //   : new FormControl('', [Validators.compose([Validators.required, Validators.pattern(accountNoRE)])]);

    this.companyNameControl = new FormControl('', [Validators.compose([
      Validators.maxLength(200), Validators.pattern(companyNameRE)
    ])]);

    // this.abnNumberControl = new FormControl('', [Validators.compose([
    //   Validators.pattern(abnRE)
    // ])]);

    this.passwordControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.minLength(this.passwordControlMinLength)
    ])]);

    this.confirmPasswordControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.minLength(this.passwordControlMinLength)
    ])]);

    this.applicantTypeControl = new FormControl('', [ Validators.compose([Validators.required]) ]);

    this.passwordControlGroup = new FormGroup({
      password: this.passwordControl,
      confirmPassword: this.confirmPasswordControl
    }, (g: FormGroup): ValidationErrors => {
      return { areEqual: g.controls.password.value !== g.controls.confirmPassword.value };
    });


  }

  async getUserDetailsFromToken() {
    try {
      this.isRequesting = true;
      const userEmail: string = atob(this.activatedRoute.snapshot.queryParamMap.get('u') || '').toLowerCase();
      const userToken: string = this.activatedRoute.snapshot.queryParamMap.get('t');

      if (userEmail && userToken) {
        this.loginService
            .getUserDetailsFromToken(userEmail, userToken)
            .subscribe((data: any) => {
              this.isRequesting = false;

              console.log(data);

              if (data.user) {
                this.validQueryParams = true;
                this.applicantDetails.email = data.user;
                this.userEmail = data.user;
              } else {
                this.validQueryParams = false;
              }
            }, (err: any) => {
              console.log(err);

              this.validQueryParams = false;
              this.isRequesting = false;
            });
      } else {
        this.validQueryParams = false;
        this.isRequesting = false;
      }

    } catch (ex) {
      console.log(ex);
    }
  }

  get invalid(): boolean {
    if (this.applicantType === 'person') {
      return this.user.invalid
        || this.passwordControlGroup.hasError('areEqual')
        || this.passwordControl.invalid
        || this.applicantTypeControl.invalid;
    } else {
      return this.user.invalid
        || this.companyNameControl.invalid
        // || this.abnNumberControl.invalid
        || this.passwordControlGroup.hasError('areEqual')
        || this.passwordControl.invalid
        || this.applicantTypeControl.invalid
        || !this.isValidABN(null, this.applicantDetails.abnNumber);
    }
  }

  isValidABN(event: any, abn: string | number) {
    if (!abn) {
      abn = this.applicantDetails.abnNumber;
    }

    if (!abn) {
      this.validABN = true;
      this.validateCompanyFields();
      return false;
    }

    if (typeof abn !== 'string') {
      this.validABN = false;
      return false;
    }

    abn = abn.replace(/\s/g, '');

    if (abn.length !== 11 || !/^\d+$/.test(abn)) {
      this.validABN = false;
      return false;
    }

    const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    let sum = 0;

    for (let i = 0; i < 11; i++) {
      let digit = parseInt(abn[i]);
      if (i === 0) {
        digit -= 1;
      }
      sum += digit * weights[i];
    }

    this.validABN = sum % 89 === 0;
    return this.validABN;
  }

  /*
      Password rules
      - password must not contain sequences of 3 or more repeated characters and
      - password must contain atleast
        - one number
        - one uppercase letter
        - one lowercase letter
        - one special character
    */
  validatePassword() {
    let status = true, msg = '';
    const pwd = this.password;

    if (pwd) {
      const hasNumber = (pwd: string) => /.*[0-9].*/.test(pwd);
      const hasLowercase = (pwd: string) => /.*[a-z].*/.test(pwd);
      const hasUppercase = (pwd: string) => /.*[A-Z].*/.test(pwd);
      const hasSpecialChar = (pwd: string) => /.*\W.*/.test(pwd);

      if (status && !hasNumber(pwd)) {
        status = false;
        msg = `Password must contain atleast one number`;
      }
      if (status && !hasLowercase(pwd)) {
        status = false;
        msg = `Password must contain atleast one lower case character`;
      }
      if (status && !hasUppercase(pwd)) {
        status = false;
        msg = `Password must contain atleast one upper case character`;
      }
      if (status && !hasSpecialChar(pwd)) {
        status = false;
        msg = `Password must contain atleast one special character`;
      }
    }

    this.pwdErrors = msg;
    return { status, msg };
  }

  validateCompanyFields() {
    if (this.applicantType === 'company') {
      if (!this.applicantDetails.companyName) {
        this.hasCompanyNameError = { status: true, msg: 'Please enter your Company Name' };
      } else {
        this.hasCompanyNameError = { status: false, msg: '' };
      }

      if (!this.applicantDetails.abnNumber) {
        this.hasCompanyABNError = { status: true, msg: 'Please enter your ABN' };
      } else {
        this.hasCompanyABNError = { status: false, msg: '' };
      }
    } else {
      this.hasCompanyNameError = { status: false, msg: '' };
      this.hasCompanyABNError = { status: false, msg: '' };
    }
  }

  submitRegistration(event: any): void {
    event.preventDefault();

    this.applicantDetails.email = this.userEmail;
    if (this.invalid) {
      this.submitErrorMessage = 'Please enter required information before submitting the request.';
      return;
    }
    if (!this.agreedToTsAndCs) {
      this.submitErrorMessage = 'Please agree to Terms and Conditions before submitting the request.';
      return;
    }

    // validate company name/abn
    this.validateCompanyFields();

    // validate password
    const isValidPasswordDetails = this.validatePassword();

    // display errors
    if (this.hasCompanyNameError.status || this.hasCompanyABNError.status || !isValidPasswordDetails.status) {
      this.submitErrorMessage = 'Please enter required information before submitting the request.';
      return;
    }

    // structuredPostal: { poBox, unitNumber, streetNumber, street, streetTypeId, state, suburb, postCode }
    const validateStructuredPostal = (structuredPostal: { poBox: string, unitNumber: string, streetNumber: string, street: string, streetTypeId: number, state: string, suburb: string, postCode: string, addressType: string }): { status: boolean, msg: string } => {

      const postcodeRE = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;
      let validPostcode: boolean = structuredPostal.postCode ? postcodeRE.test(structuredPostal.postCode || '') : false;

      const validatePOBox = () => {
        return (structuredPostal.poBox && structuredPostal.suburb && validPostcode);
      };
      const validateResAddress = () => {
        return (structuredPostal.streetNumber && structuredPostal.street && structuredPostal.streetTypeId && structuredPostal.suburb && validPostcode);
      };

      let status: boolean = true, msg: string = '';

      if (!structuredPostal.addressType) {
        status = false;
        msg = `Please provide your correspondence details address type as Residential or PO Box`;
      }

      if (status) {
        status = structuredPostal.poBox ? validatePOBox() : validateResAddress();

        if (!status) {
          if (structuredPostal.addressType === 'pobox') {
            msg = `Please provide PO Box, Suburb and Postcode.`;
          } else {
            msg = `Please provide Street Number, Street Name, Suburb and Postcode.`;
          }
        }
        // msg = status ? '' : 'Please provide either PO Box, Suburb and Postcode or Street Number, Street Name, Suburb and Postcode.';
      }
      return { status, msg };
    };

    const validateCorresponseDetails = validateStructuredPostal(this.applicantDetails.structuredPostal);
    if (!validateCorresponseDetails.status) {
      this.submitErrorMessage = validateCorresponseDetails.msg;
      return;
    }

    // purge company details if applicant type is 'person'
    if (this.applicantType === 'person') {
      this.applicantDetails.companyName = null;
      this.applicantDetails.abnNumber = null;
    }

    this.isRequesting = true;
    this.submitErrorMessage = '';
    this.loginService.register(
      this.applicantDetails.email, this.password, this.applicantDetails,
      this.registerOkCb.bind(this), this.registerErrorCb.bind(this)
    );
  }

  registerOkCb(ok: boolean): void {
    this.isRequesting = false;
    if (ok) {
      this.router.navigate(['/registrationConfirm']);
    } else {
      this.submitErrorMessage = 'Server Error';
    }
  }

  registerErrorCb(err: HttpErrorResponse): void {
    this.isRequesting = false;

    if (err) {
      if (err.error.err instanceof Array) {
        const message: string = err.error.err.toString();
        const splicedMessage: string[] = message.split(',');
        if (splicedMessage.length > 0) {
          this.submitErrorMessage = splicedMessage.join('\n');
        }
      } else if (err.error.err == 'User already exists.') {
        this.submitErrorMessage = 'You already have an account with us. Did you forget your password? Click on the Forgot password link in the login page to reset your password.';
      } else if (err.error.err.indexOf(`The password may not contain sequences of three or more repeated characters`) > -1) {
        this.submitErrorMessage = `The password may not contain sequences of three or more repeated characters`;
      } else {
        this.submitErrorMessage = 'Could not register the User.';
      }
    } else {
      this.submitErrorMessage = 'Server Error';
    }

    // this.registerBtn.nativeElement.focus();
  }

  disableComponent(status: boolean) {
    if (status) {
      this.companyNameControl.disable();
      this.passwordControl.disable();
      this.confirmPasswordControl.disable();
    } else {
      this.companyNameControl.enable();
      this.passwordControl.enable();
      this.confirmPasswordControl.enable();
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/register/register.component.ts